import { render } from "./IconApprove.vue?vue&type=template&id=96251324"
const script = {}
script.render = render

export default script